// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"3381556a","664":"97462cd9","814":"883b9d1f","896":"1541346c"}[chunkId] + ".chunk.css";
};